import { useDispatch } from 'react-redux';
import cn from 'classnames';

import UserAvatar from 'components/userAvatar';
import ZpMenuDropdown from 'components/zpMenuDropdown';
import { useCtxHistory } from 'hooks';
import { AuthService } from 'services';
import { importStatic } from 'utils';
import { prepareSalaryReportSurvey } from 'utils/v2';

import { openSignUpModal } from '../../../store/modals/actions';
import {
  POPUP_SURVEY_SOURCE,
} from '../../../utils/constant';

import classes from './index.module.css';

export const Avatar = ({
  setWrapperRef,
  avatar,
  desktopDevice,
  isCompanyUser,
  goToMatches,
  handleLogout,
  toggleMobileMenu,
}) => {
  const dispatch = useDispatch();
  const history = useCtxHistory();

  const startSurvey = async () => {
    const report = await AuthService.getSalaryReportProfile();

    const query = prepareSalaryReportSurvey({
      report,
      query: { src: POPUP_SURVEY_SOURCE.MATCHES_PAGE },
      showMatchesVersion: true,
      isLoggedIn: true,
    });

    if (query) {
      dispatch(
        openSignUpModal(
          {
            ...query,
            popupType: 'career-callout-sign-up',
          },
          true
        )
      );
      history.pushQuery(query);
    }
  };

  return (
    <div className={classes.container}>
      <div className="d-none d-lg-block" ref={setWrapperRef}>
        <ZpMenuDropdown>
          <ZpMenuDropdown.Trigger>
            <div>
              <UserAvatar
                src={avatar || importStatic('/ui-router/images/default-user.png')}
                fallbackSrc={importStatic('/ui-router/images/default-user.png')}
                onError={(e) => {
                  e.target.src = importStatic('/ui-router/images/default-user.png');
                }}
                isDesktop={desktopDevice}
              />
            </div>
          </ZpMenuDropdown.Trigger>

          <ZpMenuDropdown.Content renderInPortal={false} className={cn(classes['dropdown-content'], 'z-py-16 z-px-4')}>
            {!isCompanyUser && (
              <ZpMenuDropdown.Item
                onSelect={goToMatches}
                className="z-font-15 lightTextStyleGreyBold"
              >
                My Jobs
              </ZpMenuDropdown.Item>
            )}
            <ZpMenuDropdown.Item onSelect={() => {}} className="z-font-15 lightTextStyleGreyBold">
              <a href="/my-resume/">My Resume</a>
            </ZpMenuDropdown.Item>
            <ZpMenuDropdown.Item
              onSelect={startSurvey}
              className="z-font-15 lightTextStyleGreyBold"
            >
              My Salary Report
            </ZpMenuDropdown.Item>
            <ZpMenuDropdown.Item onSelect={() => {}} className="z-font-15 lightTextStyleGreyBold">
              <a href="/dashboard/">My Career Insights</a>
            </ZpMenuDropdown.Item>
            <ZpMenuDropdown.Separator />
            <ZpMenuDropdown.Item onSelect={() => {}} className="z-font-15 lightTextStyleGreyBold">
              <a href="/profile/">Profile</a>
            </ZpMenuDropdown.Item>
            <ZpMenuDropdown.Item
              onSelect={handleLogout}
              id="auth-logout"
              className="z-font-15 lightTextStyleGreyBold"
            >
              Log Out
            </ZpMenuDropdown.Item>
          </ZpMenuDropdown.Content>
        </ZpMenuDropdown>
      </div>

      <div className="d-block d-lg-none" onClick={toggleMobileMenu}>
        <UserAvatar
          src={avatar || importStatic('/ui-router/images/default-user.png')}
          fallbackSrc={importStatic('/ui-router/images/default-user.png')}
          isDesktop={desktopDevice}
        />
      </div>
    </div>
  );
};
